<template>
    <section class="custom-dashboard step-one" v-bind:class="{ 'mobile': this.$store.getters.isMobile }">
        <div class="container">
            <MobileMenu v-if="this.$store.getters.isMobile" />
            <h1 class="page-title text-center text-base"><strong class="text-large-heading">Step 1</strong> <br><span class="text-large-sub-heading">Which Value Drivers would you like to learn about?</span></h1>

            <div class="grid">
                <div class="col-auto" v-for="(driver, index) in drivers" :key="driver.id">
                    <card-input :driver="driver" :cardTitle="driver.name" :list="driver.children" :category="driver.abbreviation"></card-input>
                </div>
                <span class="mobile-helper-text" v-if="this.$store.getters.isMobile">Plese press "next" once you have selected all your value drivers.</span>
            </div>
        </div>

    </section>
</template>

<script>
    import router from '../router.js';
    import CardInput from '../components/CardInput';
    import EventBus from '../eventbus.js';
    import MobileMenu from './../components/MobileMenu';

    export default {
        data : function() {
            return {
                cards: []
            }
        },
        created() {
            EventBus.$on( 'stepOne.addCard', (data) => {
                this.addCard(data);
            });

            EventBus.$on( 'updateDrivers', (data) => {
                this.$store.dispatch('updateDrivers', this.drivers);
            });
        },
        computed: {
            drivers() {
                return this.$store.getters.drivers;
            }
        },
        mounted() {
            EventBus.$emit('nav.updateAction', 'button');
            EventBus.$emit('nav.updateLink', this.$route.meta.buttonLink);
        },
        methods : {
            addCard ( card ) {
                this.cards.push(card);
            }
        },
        components: {
            CardInput,
            MobileMenu
        },
    }
</script>

<style lang="css" scoped>
    .card-input {
        height: 100%;
    }

    .mobile-menu {
        margin-bottom: 4em;
    }

    @media screen and (max-width: 768px) {
        .custom-dashboard.mobile .grid .col-auto {
            padding-bottom: 0;
        }
    }

    @media screen and (max-width: 480px) {
        .custom-dashboard.mobile .container {
            padding-left: 1em;
            padding-right: 1em;
        }
    }

    .custom-dashboard.mobile .grid {
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .custom-dashboard.mobile .grid .col-auto {
        flex-direction: column;
        min-width: 60%;
        max-width: 500px;
    }

    .custom-dashboard.mobile .mobile-helper-text {
        width: 100%;
        letter-spacing: normal;
        word-spacing: normal;
        text-align: center;
        margin-top: 1em;
        margin-bottom: 100px;
        font-size: 1.25em;
        color: #4A4A4A;
    }

    @media screen and (max-width: 480px) {
        .custom-dashboard.mobile .grid .col-auto {
            width: 100%;
        }

        .page-title {
            margin-top: 4em;
        }
    }

    /* responsive catches mobile */

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/StepOne.vue